import rainbow from "@/assets/images/homepage/horizon/espace-cadet-rooftop-arc-en-ciel.jpeg";
import conceptMiddle from "@/assets/images/client-mars-2026/img-32-vue-rooftop.jpg";
import conceptTable from "@/assets/images/client-mars-2026/img-25-roof-table.jpg";

import { imageAlts } from "@/utils/seo/imageAlts";
import { LocationInfo } from "@/components/LocationInfo";
import Image from "next/image";

export const HorizonSection = () => {
  return (
    <section className="flex flex-col-reverse gap-12 px-4 py-20 ph:flex-col ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <div className="grid grid-cols-1 gap-4 ph:grid ph:grid-cols-2 ph:justify-items-center lg:grid-cols-3 lg:gap-8">
        <div className="relative aspect-video w-full overflow-hidden rounded-2xl">
          <Image
            src={rainbow}
            alt={imageAlts.rooftop.main}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="relative aspect-video w-full overflow-hidden rounded-2xl">
          <Image
            src={conceptMiddle}
            alt={imageAlts.rooftop.secondary}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="relative aspect-video w-full overflow-hidden rounded-2xl ph:col-start-1 ph:col-end-2 ph:justify-self-center lg:col-auto lg:justify-self-auto">
          <Image
            src={conceptTable}
            alt={imageAlts.rooftop.workspace}
            className="h-full w-full object-cover"
          />
        </div>
      </div>

      <div>
        <p className="mx-auto w-full max-w-5xl text-center text-2xl leading-relaxed text-black md:text-3xl">
          Profitez d&apos;une vue exceptionnelle sur tout Paris et des
          différents espaces verts répartis sur 1 000 m².
        </p>
      </div>

      <LocationInfo />
    </section>
  );
};
